import { FC, FunctionComponent, ReactNode, SVGProps } from "react";

import styles from "./BenefitCard.module.scss";

interface BenefitCardProps {
    id: string;
    Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    title: ReactNode;
    description: ReactNode;
}

const BenefitCard: FC<BenefitCardProps> = ({ Icon, title, description }) => (
    <div className={styles.card}>
        <div>
            <Icon className={styles.svg} />
        </div>
        <div>
            <p className={styles.title}>{title}</p>
            <p className={styles.desc}>{description}</p>
        </div>
    </div>
);

export default BenefitCard;
